import SwiperCarouselBase from "../utils/swiper_carousel_base"

export default class extends SwiperCarouselBase {}
